import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../i18n';
import PageHero from '../components/PageHero';
import HighlightPhrase from '../components/HighlightPhrase';
import { SectionWrap, SectionHeader, Bullets, Prose } from '../components/SectionPrimitives';
import { VIDAT_IMG } from '../lib/images';

const IMG = VIDAT_IMG.manos;

const NumberedList = ({ items, testId }) => (
  <ol className="space-y-5 mt-2 list-none pl-0" data-testid={testId}>
    {items.map((item, i) => (
      <li key={i} className="grid grid-cols-[auto_1fr] gap-5 items-start border-b border-stone-200/70 pb-5">
        <span className="text-cyan-vidat font-mono text-xs pt-1.5">{String(i + 1).padStart(2, '0')}</span>
        <span className="text-stone-700 font-light leading-relaxed">{item}</span>
      </li>
    ))}
  </ol>
);

const Diabetes = () => {
  const { content } = useI18n();
  const d = content.diabetes;
  const buttons = content.buttons;
  return (
    <main data-testid="diabetes-page">
      <PageHero eyebrow={d.eyebrow} title={d.title} lead={d.lead} image={IMG} testId="diabetes-hero" />

      <SectionWrap bg="ivory" testId="diabetes-forwhom">
        <SectionHeader title={d.forWhomTitle} />
        <Prose paragraphs={[d.forWhomP1, d.forWhomP2]} />
      </SectionWrap>

      <SectionWrap testId="diabetes-problem">
        <SectionHeader title={d.problemTitle} />
        <Prose paragraphs={[d.problemP1, d.problemP2, d.problemP3]} />
      </SectionWrap>

      <SectionWrap bg="ivory" testId="diabetes-includes">
        <SectionHeader title={d.includesTitle} />
        <p className="text-stone-700 font-light max-w-3xl mb-3">{d.includesIntro}</p>
        <p className="text-stone-700 font-light max-w-3xl mb-8">{d.includesIntro2}</p>
        <NumberedList items={d.includesList} testId="diabetes-includes-list" />
      </SectionWrap>

      <SectionWrap testId="diabetes-obtain">
        <SectionHeader title={d.obtainTitle} />
        <Bullets items={d.obtainList} />
        <div className="mt-12">
          <Link to="/programar-visita" className="btn-primary" data-testid="diabetes-cta-join">
            {buttons.joinFirstAssessments}
          </Link>
        </div>
      </SectionWrap>

      <HighlightPhrase eyebrow={d.closingTitle} dark testId="diabetes-highlight">
        {d.closingP1}
      </HighlightPhrase>

      <SectionWrap bg="ivory" testId="diabetes-closing">
        <Prose paragraphs={[d.closingP2]} />
      </SectionWrap>

    </main>
  );
};

export default Diabetes;
